<template>
	<header>
		<div style="display: block;">
			<div class="cu-custom" style="height: 45px;">
				<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
					<div class="content text-gold" style="top: 0px;">
						<div>{{$t('utrc')}}</div>
					</div>
					<div class="action" @click="changego">
						<text class="cuIcon-back" style="width: 50px;">
							<span></span>
						</text>
					</div>
				</div>
			</div>
		</div>
	</header>
	<div class="cu-card dynamic">
		<div class="cu-item grid">
			<div class="cu-form-group text-bold">
				<div class="title text-gold">{{$t('zican')}}</div>
				<uni-input class="border shadow">
					<div class="uni-input-wrapper">
						<div class="uni-input-placeholder input-placeholder" style="display: none;"></div>
						<input maxlength="140" enterkeyhint="done" autocomplete="off" class="uni-input-input"
							:value="user.money" disabled>
					</div>
				</uni-input>
			</div>
		</div>
		<div class="cu-item grid">
			<div class="cu-form-group">
				<div class="title text-gold">{{$t('jine')}}</div>
				<uni-input class="border shadow">
					<div class="uni-input-wrapper">
						<div class="uni-input-placeholder input-placeholder">{{$t('srjine')}}</div>
						<input maxlength="140" step="0.000000000000000001" enterkeyhint="done" type="number"
							class="uni-input-input">
					</div>
				</uni-input>
			</div>
		</div>
		<div class="cu-item grid">
			<div class="cu-form-group">
				<div class="title text-gold">{{$t('pipei')}}</div>
				<uni-input class="border shadow">
					<div class="uni-input-wrapper">
						<div class="uni-input-placeholder input-placeholder">{{$t('qsrdz')}}</div>
						<input maxlength="140" enterkeyhint="done" autocomplete="off" class="uni-input-input">
					</div>
				</uni-input>
			</div>
		</div>
		<div class="cu-item grid">
			<div class="cu-form-group">
				<div class="title text-gold">{{$t('anquanma')}}</div>
				<uni-input class="border shadow">
					<div class="uni-input-wrapper">
						<div class="uni-input-placeholder input-placeholder">{{$t('shuruanquanma')}}</div>
						<input maxlength="140" enterkeyhint="done" autocomplete="off" type="password"
							class="uni-input-input">
					</div>
				</uni-input>
			</div>
		</div>
		<div class="padding flex flex-direction">
			<button class="cuIcon-charge cu-btn bg-gradual-black lg">{{$t('tijiao')}}</button>
		</div>
	</div>
</template>

<script>
	import userApi from "@/api/user";
	import storeAction from "@/store/typed-actions";
	export default {
		name: "Utrc",
		components: {},
		data() {
			return {};
		},
		methods: {
			onRefresh() {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				userApi.userInfo().then((data) => {
					console.log(data.msg);
					this.user = data.msg;
					storeAction.setCurrentUserMoney(data.msg.money);
					storeAction.setCurrentUserGroup_id(data.msg.group_id);
					storeAction.setsessionStorage("money", data.msg.money);
					this.isLoading = false;
					this.$toast.clear();
				});
			},
			changego() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style>
	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
		overflow-clip-margin: 0px !important;
		overflow: clip !important;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.cu-card.dynamic {
		display: block;
	}

	.cu-card {
		display: block;
		overflow: hidden;
	}

	.cu-card.dynamic>.cu-item {
		display: block;
		background-color: #fff;
		overflow: hidden;
	}

	.cu-card>.cu-item {
		display: block;
		background-color: #fff;
		overflow: hidden;
		border-radius: 5px;
		margin: 17px;
	}

	.grid {
		display: flex;
		flex-wrap: wrap;
	}

	.text-bold {
		font-weight: 700;
	}

	.cu-form-group {
		background-color: #fff;
		padding: 0.5px 17px;
		display: flex;
		align-items: center;
		min-height: 57px;
		justify-content: space-between;
	}

	.cu-form-group .title {
		text-align: justify;
		padding-right: 17px;
		font-size: 17px;
		position: relative;
		height: 34px;
		line-height: 34px;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.cu-form-group uni-input {
		flex: 1;
		font-size: 17px;
		color: #555;
		padding-right: 11px;
	}

	uni-input {
		display: block;
		font-size: 16px;
		line-height: 1.4em;
		height: 1.4em;
		min-height: 1.4em;
		overflow: hidden;
	}

	.uni-input-placeholder {
		position: absolute;
		top: auto !important;
		font-weight: bolder;
		color: grey;
		overflow: hidden;
		text-overflow: clip;
		white-space: pre;
		word-break: keep-all;
		pointer-events: none;
		line-height: inherit;
	}

	.uni-input-input,
	.uni-input-placeholder {
		width: 100%;
	}

	.uni-input-form,
	.uni-input-input,
	.uni-input-placeholder,
	.uni-input-wrapper {
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		text-decoration: inherit;
	}

	div {
		display: block;
		unicode-bidi: isolate;
	}

	.uni-input-input {
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	.padding {
		padding: 17px;
	}

	.flex-direction {
		flex-direction: column;
	}

	.cu-btn.lg {
		padding: 0 22px;
		font-size: 18px;
		height: 45px;
	}

	[class*="cuIcon-"] {
		font-family: cuIcon;
		font-size: inherit;
		font-style: normal;
	}

	.cu-btn {
		position: relative;
		border: 0px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 17px;
		font-size: 16px;
		height: 36px;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		margin-left: 0;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		margin-right: 0;
	}

	button {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		text-align: center;
		text-decoration: none;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: transparent;
		overflow: hidden;
		color: #000;
		background-color: #f8f8f8;
		cursor: pointer;
	}

	.cu-form-group uni-input {
		flex: 1;
		font-size: 16px;
		color: #555;
		padding-right: 10px;
	}
</style>